export function checkSupportsNotifications() {
  return 'serviceWorker' in navigator
    && 'Notification' in window
    && 'PushManager' in window;
}